import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import SiteLayout from "@/components/SiteLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Legal from "@/pages/Legal";
import Contact from "@/pages/Contact";
import { LocaleProvider } from "@/i18n/LocaleContext";
import { LOCALES } from "@/i18n/messages";

/* Guard: validates the :locale param. Unknown locale → redirect to /en preserving suffix. */
const LocaleGuard = ({ children }) => {
  const location = useLocation();
  const first = location.pathname.split("/").filter(Boolean)[0];
  if (!first || !LOCALES.includes(first)) {
    const suffix = location.pathname.replace(/^\/[^/]+/, "");
    return <Navigate to={`/en${suffix || ""}${location.hash}`} replace />;
  }
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Root → default locale */}
        <Route index element={<Navigate to="/en" replace />} />

        <Route
          path=":locale"
          element={
            <LocaleGuard>
              <LocaleProvider>
                <SiteLayout />
              </LocaleProvider>
            </LocaleGuard>
          }
        >
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="legal" element={<Legal />} />
          <Route path="contact" element={<Contact />} />
        </Route>

        {/* Legacy / unknown → EN default */}
        <Route path="*" element={<Navigate to="/en" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
